<template>
  <div class="map" :style="{width:'calc(100% - '+column.labelWidth*2+'px)'}">
    <div class="search-box">
      <!--<el-input v-model="searchKey" type="search" id="search" placeholder="请输入你要定位的地址">-->
      <!--</el-input>-->
      <!--<el-button type="primary" @click="searchMap()">定位</el-button>-->
      <!--<div class="tip-box" id="searchTip"></div>-->
      <el-amap-search-box
        :search-option="searchOption"
        :on-search-result="onSearchResult">
      </el-amap-search-box>
    </div>
    <div class="amap-wrapper">
      <el-amap class="amap-box" vid="amap" :map-manager="amapManager"
               :center="center" :zoom="zoom" :events="events" :plugin="plugin">
        <el-amap-marker vid="component-marker" :position="componentMarker.position"
                        :content-render="componentMarker.contentRender"></el-amap-marker>
      </el-amap>
    </div>
  </div>
</template>

<script>
  import {AMapManager, lazyAMapApiLoaderInstance} from 'vue-amap';

  const amapManager = new AMapManager();
  //PlaceSearch初始化
  AMap.plugin('AMap.PlaceSearch', function () {
  });
  export default {
    props: ['column', 'mapRow'],
    data() {
      let that = this;
      return {
        searchKey: '',
        markers: [],
        center: [108.95, 34.27],
        zoom: 15,
        loaded: false,
        amapManager,
        componentMarker: {
          position: [121.5273285, 31.21315058]
        },
        searchOption: {
          city: "全国",
          citylimit: true,
        },
        events: {
          init(map) {
            lazyAMapApiLoaderInstance.load().then(() => {
              that.initSearch()
            });
          },
          moveend: () => {
          },
          zoomchange: () => {
          },
          click(e) {
            that.markers = [];
            let {lng, lat} = e.lnglat;
            console.log(e.lnglat)
            that.center = [lng, lat];
            that.markers.push([lng, lat]);
            // 这里通过高德 SDK 完成。
            let geocoder = new AMap.Geocoder();
            geocoder.getAddress([lng, lat], function (status, result) {
              if (status === 'complete' && result.info === 'OK') {
                if (result && result.regeocode) {
                  var info = result.regeocode.addressComponent;
                  that.searchKey = result.regeocode.formattedAddress;
                  that.$nextTick(() => {
                    that.getValue();
                  })
                }
              }
            })
          }
        },
        plugin: [
          "ToolBar",
          {
            pName: "MapType",
            defaultType: 0,
            events: {
              init(o) {
                console.log(o);
              }
            }
          }
        ],
      }
    },
    methods: {
      onSearchResult(pois) {
        const that = this;
        that.markers = [];
        let latSum = 0;
        let lngSum = 0;
        if (pois.length > 0) {
          pois.forEach((poi, index) => {
            const {lng, lat} = poi;
            if (index === 0) {
              lngSum = lng;
              latSum = lat;
              const obj = {
                position: [poi.lng, poi.lat],
                text: poi.name,
                offset: [0, 30],
              };
              that.markers.push(obj);
              that.orgAddr = poi.name;
              that.lat = poi.lat ? poi.lat.toString() : "";
              that.lon = poi.lng ? poi.lng.toString() : "";
            }
          });
          that.center = [lngSum, latSum];
          that.$nextTick(() => {
            that.getValue();
          })
        }
      },
      searchMap() {
        let that = this;
        let searchKey = this.searchKey;
        var geocoder = new AMap.Geocoder({
          city: "", //城市设为北京，默认：“全国”
        });
        geocoder.getLocation(searchKey, function (status, result) {
          console.log(status);
          console.log(result);
          if (status === 'complete' && result.geocodes.length) {
            var lnglat = result.geocodes[0].location;
            that.center = [lnglat.lng, lnglat.lat]
            that.$nextTick(() => {
              that.getValue();
            })
          } else {
            this.$message.warning("根据地址查询位置失败");
          }
        });
      },
      initSearch() {
        let that = this;
        let map = this.amapManager.getMap();
        //如果页面有设置值，则初始化地图位置
        if (this.mapRow && this.mapRow.longitude && this.mapRow.latitude) {
          that.center = [this.mapRow.latitude, this.mapRow.longitude];
        }
        AMapUI.loadUI(['misc/PoiPicker'], function (PoiPicker) {
          var poiPicker = new PoiPicker({
            input: 'search',
            placeSearchOptions: {
              map: map,
              pageSize: 10
            },
            suggestContainer: 'searchTip',
            searchResultsContainer: 'searchTip'
          })
          that.poiPicker = poiPicker;
          // 监听poi选中信息
          poiPicker.on('poiPicked', function (poiResult) {
            let source = poiResult.source;
            let poi = poiResult.item;
            if (source !== 'search') {
              poiPicker.searchByKeyword(poi.name)
            } else {
              poiPicker.clearSearchResults();
              that.markers = [];
              that.center = [poi.location.lng, poi.location.lat];
              that.getValue();
            }
          });
        })
      },
      searchByHand() {
        if (this.searchKey !== '') {
          this.poiPicker.searchByKeyword(this.searchKey)
        }
      },
      //初始化数据
      setValue() {
      },
      getValue() {
        this.$store.commit(this.$utils.storeKeys.SETFORMDATA, {
          key: this.column.lat,
          value: this.center[1]
        });
        this.$store.commit(this.$utils.storeKeys.SETFORMDATA, {
          key: this.column.lon,
          value: this.center[0]
        });
      }

    }
  }

</script>

<style scoped>
  .map {
    position: relative;
    margin: 0 auto 10px;
  }

  .amap-wrapper {
    width: 100%;
    height: 200px;
  }

  .search-box {
    z-index: 5;
    width: 350px;
    right: 10px;
    top: 10px;
    height: 30px;
    position: absolute;
  }

  .el-input {
    width: 300px;
  }

  .tip-box {
    /*width: 100%;*/
    max-height: 200px;
    position: absolute;
    top: 30px;
    z-index: 1000;
    overflow: hidden;
    overflow-y: scroll;
    background-color: #fff;
  }

  .search-box /deep/ .sugg-item {
    background: url("");
  }

  /deep/ .amap_lib_placeSearch_poi {
    display: none;
  }

  /deep/ .poi-tel {
    display: none;
  }

  /deep/ .amap_lib_placeSearch_page {
    display: none;
  }

  /deep/ .amap_lib_placeSearch .poibox .poi-img {
    display: none;
  }

  /deep/ .amap-copyright {
    display: none !important;
  }

  /deep/ .poi-more {
    display: none !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/controls/mapTemplate.vue